import React from 'react';

import {Modal, message, Tooltip, Tag } from 'antd';

import utils from '../../utils';
import fetch from '../fetch';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}


const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    params.push(`status=${keywords.status}`)
    return fetch.get(`school/calendar/temp/query?` + params.join('&'))
    .then((response) => {
        if(response.code == 200) {
            const columns = [
                {
                    key: '$index', 
                    label: '序号'
                },
                {
                    key: 'classWeek',
                    label: '周次'
                },
                {
                    key: 'weekName',
                    label: '星期'
                },
                {
                    key: 'calendar',
                    label: '时间'
                },
                {
                    key: 'isHoliday',
                    label: '是否是节假日'
                },
                {
                    key: 'termName',
                    label: '学期',
                    width: 80
                },
                {
                    key: 'checkFlag',
                    label:  '状态',
                    width: 100,
                    render: (d) => {
                        if (d === 2) {
                            return <Tag color='#2db7f5'>检测通过</Tag>
                        } else if (d === 3) {
                            return <Tag color='#f50'>检测不通过</Tag>
                        } else if (d === 4) {
                            return <Tag color='#87d068'>导入成功</Tag>
                        }
                    }
                },
                {
                    key: 'checkDesc',
                    label:  '状态描述',
                    width: 100,
                    render: (d) => {
                        return (
                            <Tooltip title={d}>
                                <span>{d}</span>
                            </Tooltip>
                        )
                    }
                },
            ]
            return {
                headers : utils.columns(columns),
                data: response.payload.data,
            }
        }
    }).then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data || []).length ? '' : '暂无数据...'
        }))
    )
}

const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.warn({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

const remove = (ids) => {
    return fetch.post('school/calendar/temp/delete', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

const submit = () => {
    return fetch.get('school/calendar/temp/submit')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

export default {
    setRefresh,
    onSelectData,
    onSelect,
    getSelection,
    querySearch,
    batchRemove,
    submit
}